/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @type {string} auth action types.
 */

export const SET_MOBILE_NO = '[AUTH] SET_MOBILE_NO';
export const SET_USERNAME = '[AUTH] SET_USERNAME';
export const SET_LOADING = '[AUTH] SET_LOADING';
export const SET_VERIFICATION_OTP = '[AUTH] SET_VERIFICATION_OTP';
export const SET_USER_ID = '[AUTH] SET_USER_ID';
export const SET_USERDATA = '[AUTH] SET_USERDATA';

